import { ApiVersion } from 'app/shared/models/api-version';

export class ServiceConnectionModel {
    identifier = '';
    apiVersion = ApiVersion.FirstVersion;
}
